export default "__VITE_ASSET__9d928458__"